import styled from '@emotion/styled';
import { JockeyAndTrainerDetails } from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/JockeyAndTrainerDetails';
import { Selection } from 'src/domains/sportsbook/webview/components/Selection';
import { withConfig } from 'src/withConfig';

export const SilkCellRaceBox = styled('div', { label: 'SilkCellRaceBox' })`
    align-items: center;
    display: flex;
    flex: 0 0 36px;
    height: 100%;
    justify-content: center;
    position: relative;
    width: 36px;
`;

export const SelectionWrapper = styled(Selection, { label: 'SelectionWrapper' })`
    align-self: stretch;
`;

export const RunnerCell = styled('div', { label: 'RunnerCell' })`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 12px;
    justify-content: start;
    padding: 6px 6px 6px 12px; /* Should be 8px 12px. There is a difference between figma nad prod. */
    overflow: hidden;
`;

export const RunnerCellDetails = withConfig(theme => styled('div', { label: 'RunnerCellDetails' })`
    align-items: flex-start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    overflow: hidden;
`);

export const JockeyAndTrainerDetailsBox = withConfig(theme => styled(JockeyAndTrainerDetails, { label: 'JockeyAndTrainerDetailsBox' })`
    align-items: flex-start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    overflow: hidden;
    width: 100%;
`);
